import React, { useEffect, useState } from "react";
import TableHeader from "./TableHeader";
import TableItem from "./TableItem";
import TableFooter from "./TableFooter";
import EmptyAssignment from "assets/svgs/empty_assignment";
import CardDiv from "modules/common/card-div/CardDiv";
import { Row } from "react-bootstrap";
import useAssignedOrders from "modules/customerlist/store";
import PlaceHolderActionable from "./PlaceHolderActionable";
import { getCurrentUserRole } from "modules/utilities/utility";
import moment from "moment";

function ActionableTable({
  data,
  newPage,
  details,
  setClear,
  setState,
  setDocData,
  setPageNumber,
  assignedOrder,
  actionableTabs,
  setQueryParams,
  paginationData,
  setActiveCaseId,
  actionableLoading,
  filterBy,
  setFilterBy,
}) {
  useEffect(() => {}, [data]);
  const [sortOrder, setSortOrder] = useState("desc");
  const { isLoading } = useAssignedOrders();
  const [unansFilter, setUnansFilter] = useState("");
  const [sort, setSort] = useState("asc");

  const renderTableItems = () => {
    if (!assignedOrder && filterBy?.length) {
      return data?.length !== 0 && data?.length ? (
        data
          ?.sort(
            (orderA, orderB) => orderA.reminder_date - orderB.reminder_date
          )
          ?.map((item, index) => (
            <Row className="mt-0" style={{ margin: "0 0 0 .3px" }} key={index}>
              <TableItem
                item={item}
                rounded={index === data?.length - 1}
                setState={setState}
                setDocData={setDocData}
                assignedOrder={assignedOrder}
                setActiveCaseId={setActiveCaseId}
              />
            </Row>
          ))
      ) : (
        <div className="">
          <CardDiv
            component={
              <div className="d-flex align-items-center justify-content-evenly">
                <EmptyAssignment />
                <h2 className="m-0">No data available</h2>
              </div>
            }
          />
        </div>
      );
    }
    if (getCurrentUserRole() === "medical") {

      let filteredData = data;

      if (unansFilter !== "") {
        filteredData = filteredData.filter(
          (eachEng) => eachEng.unanswered_count == unansFilter
        );
      }

      if (sort !== "") {
        filteredData.sort((eachEng1, eachEng2) => {
          if (sort === "asc") {
            return (
              new Date(eachEng1.updated_at) - new Date(eachEng2.updated_at)
            );
          } else {
            return (
              new Date(eachEng2.updated_at) - new Date(eachEng1.updated_at)
            );
          }
        });
      }

      return filteredData.length !== 0 && filteredData ? (
        filteredData?.map((item, index) => (
          <Row className="mt-0" style={{ margin: "0 0 0 .3px" }} key={index}>
            <TableItem
              item={item}
              rounded={index === filteredData.length - 1}
              setState={setState}
              setDocData={setDocData}
              assignedOrder={assignedOrder}
              setActiveCaseId={setActiveCaseId}
            />
          </Row>
        ))
      ) : (
        <div className="">
          <CardDiv
            component={
              <div className="d-flex align-items-center justify-content-evenly">
                <EmptyAssignment />
                <h2 className="m-0">No data available</h2>
              </div>
            }
          />
        </div>
      );
    } else {
      return data?.length !== 0
        ? data?.sort((orderA, orderB) => {
          const dateA = moment(orderA.reminder_date);
          const dateB = moment(orderB.reminder_date);
          if (sortOrder === "desc") {
            return dateA.diff(dateB);
          } else if (sortOrder === "asc") {
            return dateB.diff(dateA);
          }
        }).map((item, index) => (
            <Row className="m-0" key={index}>
              <TableItem
                item={item}
                rounded={index === data?.length - 1}
                setState={setState}
                setDocData={setDocData}
                assignedOrder={assignedOrder}
                setActiveCaseId={setActiveCaseId}
              />
            </Row>
          ))
        : !isLoading && (
            <div className="border p-3 rounded-bottom border-top-0">
              <div className="d-flex align-items-center justify-content-evenly">
                <EmptyAssignment />
                <h2 className="m-0">No data available</h2>
              </div>
            </div>
          );
    }
  };

  return (
    <div style={{ height: "85vh" }}>
      <CardDiv
        component={
          <>
            <TableHeader
              data={data}
              details={details}
              setClear={setClear}
              assignedOrder={assignedOrder}
              setPageNumber={setPageNumber}
              setQueryParams={setQueryParams}
              setFilterBy={!assignedOrder ? setFilterBy : undefined}
              setUnansFilter={setUnansFilter}
              unansFilter={unansFilter}
              sort={sort}
              setSort={setSort}
            />
            <div
              style={{
                maxHeight: "80%",
                overflowY: "scroll",
                overflowX: "hidden",
              }}
              className="scrollable-container"
            >
              {actionableTabs ? (
                actionableLoading ? (
                  <PlaceHolderActionable />
                ) : (
                  renderTableItems()
                )
              ) : isLoading ? (
                <PlaceHolderActionable />
              ) : (
                renderTableItems()
              )}
            </div>

            {paginationData && true && (
              <TableFooter paginationData={paginationData} newPage={newPage} />
            )}
          </>
        }
      />
    </div>
  );
}

export default ActionableTable;
